<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="m12 20.5-8.522-8.635c-1.536-1.492-1.917-3.77-.945-5.657.725-1.409 2.103-2.393 3.703-2.645a5.136 5.136 0 0 1 4.372 1.372L12 6.286l1.392-1.351a5.136 5.136 0 0 1 4.373-1.372c1.6.252 2.977 1.236 3.703 2.645.97 1.885.59 4.163-.945 5.654L12 20.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
